import RequestPrescreenerBaseCategoryController from './prescreener--base-category';

export default class RequestPrescreenerClientPreferences extends RequestPrescreenerBaseCategoryController {}
